import { Button } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { buttonRootCss } from "./SupportCenterChatButton.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

const SupportCenterChatButton = ({
  launchChat,
}: {
  launchChat: () => void;
}) => {
  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.secondary}
      dataProps={{ "data-qa-selector": "support-center-chat-button" }}
      onClick={launchChat}
      actionName={actionNames.interact}
      objectType={objectTypes.user}
      streamProperties={{
        description: "Salesforce Support chat button clicked",
      }}
      __cssFor={{ root: buttonRootCss }}
    >
      Chat with support
    </ButtonWithTrackEvent>
  );
};

export { SupportCenterChatButton };
